<template>
  <div class="content-box">
    <Title />
    <div class="title-right">
      <el-link href="/detail--6658415.html" target='_blank'>
        <img src="/Public/Upload/image/20260615/1781506393124338.gif"
      /></el-link>
      
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      dataNav: [
        {
          value: "旅游",
          label: "滚动播报",
        },
        {
          value: "网约车",
          label: "网约车",
        },
        {
          value: "聚合平台",
          label: "聚合平台",
        },
        {
          value: "共享单车",
          label: "共享单车",
        },
        {
          value: "共享汽车",
          label: "共享汽车",
        },
        {
          value: "顺风车",
          label: "顺风车",
        },
        {
          value: "租车",
          label: "租车",
        },
        {
          value: "停车",
          label: "停车",
        },
        {
          value: "地图",
          label: "地图导航",
        },
        {
          value: "代驾",
          label: "代驾",
        },
        {
          value: "酒店",
          label: "酒店",
        },
        {
          value: "民宿",
          label: "民宿短租",
        },
        {
          value: "自驾游",
          label: "自驾游",
        },
        {
          value: "红色旅游",
          label: "红色旅游",
        },
        {
          value: "智慧 旅游",
          label: "智慧旅游",
        },
        {
          value: "商旅",
          label: "商旅",
        },
        {
          value: "汽车 电商",
          label: "汽车电商",
        },
        {
          value: "汽车 后市场",
          label: "汽车后市场",
        },
        {
          value: "度假",
          label: "度假",
        },
        {
          value: "出境游",
          label: "出境游",
        },
        {
          value: "本地游",
          label: "本地游",
        },
        {
          value: "酒旅",
          label: "酒旅",
        },
        {
          value: "文旅",
          label: "文旅",
        },{
          value: "蔚来",
          label: "蔚来",
        },{
          value: "理想汽车",
          label: "理想汽车",
        },{
          value: "小鹏汽车",
          label: "小鹏汽车",
        },{
          value: "特斯拉",
          label: "特斯拉",
        },
        {
          value: "AI 旅游",
          label: "AI旅游",
        }, {
          value: "极氪",
          label: "极氪",
        },
      ],
      params: {
        json: 0,
        filter: [
          "研报",
          "分析",
          "（PPT）",
          "（全文）",
          "陈礼腾",
          "曹磊",
          "赵占领",
          "董毅智",
        ],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    handleSelect(index) {
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>
